import { create } from 'zustand';

const TEST_MODE_KEY = 'ski_service_test_mode';

interface TestModeState {
  isTestMode: boolean;
  toggleTestMode: () => void;
}

export const useTestMode = create<TestModeState>((set, get) => ({
  isTestMode: localStorage.getItem(TEST_MODE_KEY) === 'true',

  toggleTestMode: () => {
    const next = !get().isTestMode;
    localStorage.setItem(TEST_MODE_KEY, String(next));
    set({ isTestMode: next });
  },
}));
